import React from "react";
import { gql, useMutation } from "@apollo/client";
import { useLogin } from "../Redux/Auth/Auth";
import useField from "./useField";
import Error from "./Error";
import client from "../client";

export default () => {
  const [remoteLogin, { data, loading }] = useMutation(
    gql`
      mutation Login($username: String!, $password: String!) {
        login(username: $username, password: $password) {
          apiKey
          error
        }
      }
    `,
    {
      onCompleted: (data) => {
        client
          .resetStore()
          .then(() => data.login.apiKey && login(data.login.apiKey));
      },
    },
  );
  const [username, usernameError, usernameProps] = useField((value) => {
    if (value.length < 3) return "Must be at least 3 characters";
    if (value.length > 256) return "Must be no more than 256 characters";
    return null;
  });
  const [password, passwordError, passwordProps] = useField((value) => {
    if (value.length < 3) return "Must be at least 8 characters";
    if (value.length > 256) return "Must be no more than 1024 characters";
    return null;
  });
  const login = useLogin();
  return (
    <div>
      <h1>Please log in or register</h1>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (loading) return;
          if (usernameError || passwordError) return;
          remoteLogin({
            variables: {
              username,
              password,
            },
          });
        }}
      >
        <p>
          <label>
            Username <input type="text" {...usernameProps} />
          </label>
          {usernameError && <Error>{usernameError}</Error>}
        </p>
        <p>
          <label>
            Password{" "}
            <input type="password" {...passwordProps} value={password} />
          </label>
          {passwordError && <Error>{passwordError}</Error>}
        </p>
        <p>
          <button disabled={loading}>
            {loading ? "Logging in..." : "Login/Register"}
          </button>
        </p>
      </form>
      {data?.login?.error && <Error>{data.login.error}</Error>}
    </div>
  );
};
